module.exports = __webpack_public_path__ + "img/Facebook.757f931b.svg";